/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
import { CandidateOpportunityEntity } from './candidate-opportunity-entity';
import { ExperienceEntity } from './experience-entity';
export class CandidateOpportunityWarmingQuestionExperienceEntity extends Entity {
  candidateOpportunity: CandidateOpportunityEntity | null = null;
  candidateOpportunityId: string | null = null;
  createdAt: string | null = null;
  experience: ExperienceEntity | null = null;
  experienceId: string | null = null;
  id: string = '';
  updatedAt: string | null = null;
  static override key = 'CandidateOpportunityWarmingQuestionExperience';
  static override get schema() {
    return {
      candidateOpportunity: CandidateOpportunityEntity,
      experience: ExperienceEntity,
    };
  }
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'CandidateOpportunityWarmingQuestionExperience' in input
    ) {
      const { CandidateOpportunityWarmingQuestionExperience: wrapped, ...rest } = input as {
        CandidateOpportunityWarmingQuestionExperience: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}